import request from "@/utils/request";

export default function list(productId,type) {
    return request({
        url: `/storeProductResource/agency/list/`+productId+'/'+type,
        method: 'get',
    })
}
